import { Link, useLocation } from "react-router-dom";
import { Home, DollarSign, Receipt, FileText, Calculator, Settings } from "lucide-react";
import { motion } from "framer-motion";

export default function Navigation() {
  const location = useLocation();
  
  const links = [
    { path: "/", label: "Dashboard", icon: Home },
    { path: "/income", label: "Income", icon: DollarSign },
    { path: "/expenses", label: "Expenses", icon: Receipt },
    { path: "/deductions", label: "Deductions", icon: FileText },
    { path: "/calculator", label: "Calculator", icon: Calculator },
    { path: "/settings", label: "Settings", icon: Settings },
  ];
  
  return (
    <nav className="border-b border-border bg-card/50 backdrop-blur-xl sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
              <FileText className="w-6 h-6 text-primary-foreground" />
            </div>
            <span className="text-2xl font-heading font-light tracking-tight" data-testid="app-title">TaxFlow AI</span>
          </Link>
          
          <div className="flex items-center space-x-1">
            {links.map((link) => {
              const Icon = link.icon;
              const isActive = location.pathname === link.path;
              
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className="relative px-4 py-2 rounded-lg text-sm font-medium transition-colors hover:text-primary"
                  data-testid={`nav-${link.label.toLowerCase()}`}
                >
                  <div className="flex items-center space-x-2">
                    <Icon className="w-4 h-4" />
                    <span className="hidden sm:inline">{link.label}</span>
                  </div>
                  {isActive && (
                    <motion.div
                      layoutId="activeNav"
                      className="absolute inset-0 bg-primary/10 rounded-lg -z-10"
                      transition={{ type: "spring", stiffness: 380, damping: 30 }}
                    />
                  )}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </nav>
  );
}